"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scripts = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const components_1 = require("@ttark/components");
const jotai_1 = require("jotai");
const atom_1 = require("../atom");
const Scripts = () => {
    const { disableInlineScripts } = (0, jotai_1.useAtomValue)(atom_1.$RenderConfig);
    return (0, jsx_runtime_1.jsx)(components_1.Scripts, { hasCSPRequirement: disableInlineScripts });
};
exports.Scripts = Scripts;
